<template>
	<div>
		<div class="w-full">
			<carousel
				:autoplay="true"
				:autoplayTimeout="8000"
				:perPage="1"
				:paginationEnabled="false"
				:loop="true"
			>
				<slide
					v-for="(banners_item, banners_index) in banners"
					:key="banners_index"
					class="flex justify-center"
				>
					<img
						style="width: 100%"
						v-if="banners_item.image_link_url"
						class="cursor-pointer"
						@click.native="openLink(banners_item.image_link_url)"
						:src="banners_item.image"
					/>
					<img style="width: 100%" v-else :src="banners_item.image" />
				</slide>
			</carousel>
		</div>

		<Container class="homeContainer">
			<Card class="homeNewsFeatured relative pt-16">
				<div
					class="
						bg-primary
						text-white
						top-0
						left-0
						w-full
						absolute
						uppercase
						px-6
						py-2
						rounded-t-sm
					"
				>
					<span>{{ $t('news_featured') }}</span>
				</div>
				<div>
					<carousel
						:autoplay="true"
						:autoplayTimeout="6000"
						:perPage="1"
						:paginationActiveColor="'#000'"
						:paginationPadding="5"
						:loop="true"
					>
						<slide
							v-for="(featured_news_item, featured_news_index) in featured_news"
							:key="featured_news_index"
						>
							<div class="flex">
								<div class="lg:w-1/6"></div>
								<div class="lg:w-4/6">
									<div>
										<router-link
											class="no-underline"
											:to="'noticias/' + featured_news_item.id"
										>
											<h2
												class="
													text-primary
													font-bold
													text-lg
													m-0
													no-underline
													hover:underline
												"
											>
												{{ featured_news_item.title }}
											</h2>
										</router-link>
										<span class="text-secondary italic text-sm">
											{{ featured_news_item.category }}
										</span>
									</div>
									<div
										class="
											object-cover
											overflow-hiddenrounded-sm
											mt-2
											flex
											justify-center
										"
									>
										<div v-if="featured_news_item.image">
											<img :src="featured_news_item.image" class="imgNewsLg" />
										</div>
										<div v-else>
											<img
												:src="featured_news_item.category_image"
												class="imgNewsLg"
											/>
										</div>
									</div>
									<div
										clasS="text-secondary text-sm my-3 text-justify"
										v-html="featured_news_item.description"
									></div>
									<div class="flex justify-between self-end text-sm">
										<div>
											{{
												featured_news_item.publishing_date
													| moment('DD/MM/YYYY')
											}}
										</div>
										<router-link
											class="
												text-primary
												font-normal
												cursor-pointer
												no-underline
												hover:underline
											"
											:to="'noticias/' + featured_news_item.id"
											>{{ $t('read_more') }}</router-link
										>
									</div>
								</div>
								<div class="lg:w-1/6"></div>
							</div>
						</slide>
					</carousel>
				</div>
			</Card>

			<Card class="homeBonuses relative pt-16">
				<div
					class="
						bg-primary
						text-white
						top-0
						left-0
						w-full
						absolute
						uppercase
						px-6
						py-2
						rounded-t-sm
					"
				>
					<span>{{ $t('Bonos') }}</span>
				</div>
				<div class="py-5 lg:px-10 xs:px-3">
					<carousel
						:autoplay="true"
						:autoplayTimeout="4000"
						:perPage="1"
						:paginationEnabled="false"
						:navigationEnabled="true"
						:loop="true"
					>
						<slide
							v-for="(bonuses_item, bonuses_index) in bonuses"
							:key="bonuses_index"
						>
							<div>
								<img
									class="w-40 block mx-auto"
									v-if="bonuses_item.image"
									:src="bonuses_item.image"
								/>
								<img
									class="w-40 block mx-auto"
									v-else
									:src="bonuses_item.company_image"
								/>
								<div class="text-center">
									<h2
										class="text-lg block font-semibold mt-6 mb-3"
										:style="`color:${bonuses_item.company_style}`"
									>
										{{ bonuses_item.title }}
									</h2>
									<div v-html="bonuses_item.body"></div>
									<div class="mt-5">
										<span class="block text-sm">{{ $t('bonus_text') }}:</span>
										<span class="block text-sm">{{
											bonuses_item.valid_until | moment('DD/MM/YYYY')
										}}</span>
									</div>
								</div>
							</div>
						</slide>
					</carousel>
				</div>
			</Card>

			<Card class="homeNews relative pt-16">
				<div
					class="
						bg-primary
						text-white
						top-0
						left-0
						w-full
						absolute
						uppercase
						px-6
						py-2
						rounded-t-sm
					"
				>
					<span>{{ $t('latest_news') }}</span>
				</div>
				<div class="homeNewsWrapper">
					<div
						class="homeNewsContainer"
						v-for="(latest_news_item, latest_news_index) in latest_news"
						:key="latest_news_index"
					>
						<div>
							<div>
								<router-link
									class="no-underline"
									:to="'noticias/' + latest_news_item.id"
								>
									<h2
										class="
											text-primary
											font-bold
											text-lg
											m-0
											no-underline
											hover:underline
										"
									>
										{{ latest_news_item.title }}
									</h2>
								</router-link>
								<span class="text-secondary italic text-sm">
									{{ latest_news_item.category.category }}
								</span>
							</div>
							<div
								class="
									object-cover
									overflow-hidden
									rounded-sm
									flex
									justify-center
								"
							>
								<div v-if="latest_news_item.image">
									<img :src="latest_news_item.image" class="imgNews" />
								</div>
								<div v-else>
									<img :src="latest_news_item.category_image" class="imgNews" />
								</div>
							</div>
							<div
								clasS="text-secondary my-3 text-sm text-justify"
								v-html="latest_news_item.description"
							></div>
							<div class="flex justify-between self-end">
								<div class="text-sm">
									{{ latest_news_item.publishing_date | moment('DD/MM/YYYY') }}
								</div>
								<router-link
									class="font-normal no-underline hover:underline text-sm"
									:to="'noticias/' + latest_news_item.id"
									>{{ $t('read_more') }}</router-link
								>
							</div>
						</div>
					</div>
				</div>
			</Card>

			<Card class="homeLinks relative pt-16">
				<div
					class="
						bg-primary
						text-white
						top-0
						left-0
						w-full
						absolute
						uppercase
						px-6
						py-2
						rounded-t-sm
					"
				>
					<span>{{ $t('links') }}</span>
				</div>
				<div class="homeLinksContainer">
					<div
						class="px-8 py-3"
						v-for="(links_item, links_index) in links"
						:key="links_index"
					>
						<div>
							<a
								class="
									flex
									items-center
									text-primary
									no-underline
									hover:underline
								"
								:href="links_item.link_url"
								target="_blank"
							>
								<img
									class="mr-2"
									:src="`https://s2.googleusercontent.com/s2/favicons?domain_url=${links_item.link_url}`"
									alt="link.link_name"
								/>
								<span>{{ links_item.link_name }}</span>
							</a>
						</div>
					</div>
				</div>
			</Card>
		</Container>
	</div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import gql from 'graphql-tag'

export default {
	apollo: {
		banners: {
			query: gql`
				query ($country_id: bigint!) {
					banners(
						where: { country_id: { _eq: $country_id }, active: { _eq: true } }
						order_by: { publishing_date: desc }
					) {
						id
						image {
							url
						}
					}
				}
			`,
			variables() {
				return {
					country_id: this.country_id
				}
			},
			update(data) {
				return data.banners.map(item => {
					const image =
						item.image && item.image.url
							? `${
									process.env.VUE_APP_API_URL
							  }/public/assets/images/?key=${item.image.url.slice(1)}`
							: undefined

					return {
						id: item.id,
						image_link_url: item.image_link_url,
						image: image
					}
				})
			}
		},
		featured_news: {
			query: gql`
				query ($country_id: bigint!) {
					news(
						where: {
							country_id: { _eq: $country_id }
							active: { _eq: true }
							featured: { _eq: true }
						}
						order_by: { publishing_date: desc }
					) {
						id
						title
						image {
							url
						}
						news_category {
							category_name
							image {
								url
							}
						}
						description
						publishing_date
					}
				}
			`,
			variables() {
				return {
					country_id: this.country_id
				}
			},
			update(data) {
				return data.news.map(item => {
					const image =
						item.image && item.image.url
							? `${
									process.env.VUE_APP_API_URL
							  }/public/assets/images/?key=${item.image.url.slice(
									1
							  )}&width=400`
							: undefined

					return {
						id: item.id,
						title: item.title,
						image: image,
						category: item.news_category.category_name,
						description: item.description,
						publishing_date: item.publishing_date
					}
				})
			}
		},
		bonuses: {
			query: gql`
				query ($country_id: bigint!) {
					bonuses(
						where: { country_id: { _eq: $country_id }, active: { _eq: true } }
						order_by: { valid_until: asc }
					) {
						id
						title
						body
						valid_until
						image {
							url
						}
						company {
							image {
								url
							}
							style
						}
					}
				}
			`,
			variables() {
				return {
					country_id: this.country_id
				}
			},
			update(data) {
				return data.bonuses.map(item => {
					const image =
						item.image && item.image.url
							? `${
									process.env.VUE_APP_API_URL
							  }/public/assets/images/?key=${item.image.url.slice(
									1
							  )}&width=400`
							: undefined

					const company_image =
						item.company.image && item.company.image.url
							? `${
									process.env.VUE_APP_API_URL
							  }/public/assets/images/?key=${item.company.image.url.slice(
									1
							  )}&width=400`
							: undefined

					return {
						id: item.id,
						title: item.title,
						body: item.body,
						valid_until: item.valid_until,
						image: image,
						company_image: company_image,
						company_style: item.company.syle
					}
				})
			}
		},
		latest_news: {
			query: gql`
				query ($country_id: bigint!) {
					news(
						where: { country_id: { _eq: $country_id }, active: { _eq: true } }
						order_by: { publishing_date: desc }
						limit: 2
					) {
						id
						title
						image {
							url
						}
						news_category {
							category_name
							image {
								url
							}
						}
						description
						publishing_date
					}
				}
			`,
			variables() {
				return {
					country_id: this.country_id
				}
			},
			update(data) {
				return data.news.map(item => {
					const image =
						item.image && item.image.url
							? `${
									process.env.VUE_APP_API_URL
							  }/public/assets/images/?key=${item.image.url.slice(
									1
							  )}&width=200`
							: undefined

					return {
						id: item.id,
						title: item.title,
						image: image,
						category: item.news_category.category_name,
						description: item.description,
						publishing_date: item.publishing_date
					}
				})
			}
		},
		links: {
			query: gql`
				query ($country_id: bigint!) {
					links(
						where: { country_id: { _eq: $country_id }, active: { _eq: true } }
						order_by: { order: asc }
					) {
						link_name
						link_url
					}
				}
			`,
			variables() {
				return {
					country_id: this.country_id
				}
			}
		}
	},
	data() {
		return {
			country_id: this.$store.state.login.user.country_id
		}
	},
	components: {
		Carousel,
		Slide
	},
	methods: {
		openLink(link) {
			window.open(link, '_blank')
		}
	}
}
</script>

<style scoped>
.homeNewsFeatured {
	grid-area: NewsFeatured;
}

.homeBonuses {
	grid-area: Bonuses;
}

.homeNews {
	grid-area: News;
}

.homeLinks {
	grid-area: Links;
}

.homeContainer {
	display: grid;
	grid-gap: 20px;
	grid-template-columns: 1fr 1fr 400px;
	grid-template-rows: auto;
	grid-template-areas: 'NewsFeatured NewsFeatured Bonuses' 'News News Links' '_ _ Links';
}

@media (max-width: 768px) {
	.homeContainer {
		grid-template-columns: 100%;
		grid-template-areas: 'NewsFeatured' 'Bonuses' 'News' 'Links';
	}
	.h-custom300 {
		max-height: 250px !important;
	}
}

.imgNews {
	max-height: 150px;
}

.imgNewsLg {
	max-height: 250px;
}

.banner-content {
	background: #00000052;
	padding: 20px;
	font-size: 20px;
	color: #fff;
	font-weight: bold;
	width: 100%;
	position: absolute;
	bottom: 0;
}

/* Featured and last news */

.homeNewsWrapper {
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-gap: 20px;
}

@media (max-width: 1000px) {
	.homeNewsWrapper {
		grid-template-columns: 1fr;
	}
}

.homeNewsContainer > div {
	display: grid;
	height: 100%;
}

.h-custom300 {
	max-height: 300px;
}

/* Links */

.homeLinksContainer > div:nth-child(odd) {
	background: #f3f3f3;
}
</style>
